export default __webpack_public_path__ + "static/mini-9-458ddfcd2ec19ee14ef8a2fae2d31c67.png";